import theme from 'src/shared/theme';
import { PlacementAreaDesignerManager } from '../placementAreaDesignerManager';
import PlacementAreaDesignerPlugin from './placementAreaDesignerPlugin';

export class placementAreaDesignerDocumentSizePlugin implements PlacementAreaDesignerPlugin {
    private manager!: PlacementAreaDesignerManager;

    private layer!: paper.Layer;
    private documentSizeLabel!: paper.Group;

    public create = (manager: PlacementAreaDesignerManager) => {
        this.manager = manager;
        this.layer = new manager.paper.Layer();
        this.layer.bringToFront();

        this.documentSizeLabel = new manager.paper.Group();
        this.documentSizeLabel.applyMatrix = false;
        this.layer.addChild(this.documentSizeLabel);

        this.createLabel(this.documentSizeLabel);

        this.updateDocumentSizeLabel();
    };

    private createLabel = (group: paper.Group) => {
        const rect = new this.manager.paper.Path.Rectangle(new this.manager.paper.Rectangle(0, 0, 80, 30), new this.manager.paper.Size(3, 3));
        rect.strokeScaling = false;
        rect.strokeWidth = 0;
        rect.strokeColor = new this.manager.paper.Color(theme.app.primary);

        const text = new this.manager.paper.PointText(new this.manager.paper.Point(40, 20));
        text.content = '';
        text.fontSize = 12;
        text.fontWeight = 400;
        text.fontFamily = 'Montserrat, sans-serif';
        text.fillColor = new this.manager.paper.Color(theme.app.primary);
        text.justification = 'center';

        group.addChildren([rect, text]);
    };

    private getDocumentSizeLabel = () => {
        let content = '';
        if (this.manager.placementItem) {
            let width: number | string = this.manager.placementItem.data.width / this.manager.placementItem.data.unit.ratio;
            let height: number | string = this.manager.placementItem.data.height / this.manager.placementItem.data.unit.ratio;

            width = width % 1 === 0 ? width.toString() : width.toFixed(2);
            height = height % 1 === 0 ? height.toString() : height.toFixed(2);

            content = this.manager.placementItem ? width + ' x ' + height + ' ' + this.manager.placementItem.data.unit.label : '';
        }

        return content;
    };

    public updateDocumentSizeLabel = () => {
        const scale = 1 / this.manager.paper.view.zoom;
        this.documentSizeLabel.scaling = new this.manager.paper.Point(scale, scale);

        if (this.manager.placementItem) {
            this.documentSizeLabel.position = this.manager?.placementItem?.bounds.topCenter.add(
                new this.manager.paper.Point(0, -10 / this.manager.paper.view.zoom)
            );
            (this.documentSizeLabel.children[1] as paper.PointText).content = this.getDocumentSizeLabel();
        }

        this.layer.visible = true;
    };

    public onDocumentSizeChanged = () => {
        this.updateDocumentSizeLabel();
    };
}
